import React from 'react';

interface EventContextType {
  updateEvents: () => void;
}

const EventContext = React.createContext<EventContextType>({
  updateEvents: () => {}  // Proporcionar una función vacía por defecto
});

export default EventContext;
